import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ManualClusterSelect from '../../../components/manualClusterModal';
import ReactSelect from '../../../components/ReactSelect';

class AdditionalBox extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        const options = this.props.seasons
            ? this.props.seasons?.map((item) => ({ label: item.name, value: item.id }))
            : [];
        options.push({
            label: (
                <div className="w-100 d-flex align-items-center justify-content-center">
                    <button
                        className="button button-filled button-primary btn d-flex align-items-center justify-content-center"
                        onClick={this.props.onOpenSettingsModal}
                    >
                        {t('search.custom_keywords.add_edit')}
                    </button>
                </div>
            ),
            value: 'add/edit',
        });

        return (
            <>
                <div className="table-additional-view">
                    <div className="box-with-switch gap-10 d-flex align-items-center">
                        <ReactSelect
                            options={options}
                            value={options.find((x) => x.value === this.props.season)}
                            isSearchable={false}
                            // placeholder="Start Date"
                            onChange={(value) => {
                                if (value !== 'add/edit') {
                                    this.props.getData(value);
                                }
                            }}
                            blurInputOnSelect={true}
                            classname="mr-10"
                        />
                    </div>
                    {!!this.props.selectedItems?.length && (
                        <div className="d-flex align-items-center">
                            <div>
                                <ManualClusterSelect
                                    current_url={this.props.current_url}
                                    csrf_token={this.props.csrf_token}
                                    selectedItems={this.props.selectedItems}
                                    header="Add To Keyword List"
                                    cluster_type="keyword"
                                    onRemoveAllSelected={this.props.onRemoveAllSelected}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </>
        );
    }
}

export default withTranslation()(AdditionalBox);
